import { Component } from 'react';
import Header from '../../../Header';
import MessageLink from '../../../MessageLink';
import Footer from '../../../Footer';
import Lgpd from '../../../Lgpd';
import DocumentLink from '../../../DocumentLink';
import ErrorBoundary from '../../../ErrorHandler/ErrorBoundary';
import InfoComponent from '../../InfoComponent';

class CartilhasPage extends Component {
	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<main>

					<InfoComponent image={"plano-b-cartilha"} page={'plano-b-cartilha'}></InfoComponent>

					{/* Content page */}
					<div className="_the-content page-planos pb-10 mb-4">
						<div className='container'>
							<div className="row">

								<ErrorBoundary><DocumentLink fileImg={'../../assets/img/Cartilha do Participante Plano B_Prancheta 1.png'} url={'ObterCartilhasB'} /></ErrorBoundary>

							</div>
						</div>
					</div>
				</main>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default CartilhasPage;